import styled from "styled-components";

export const ProfileContainer = styled.div`
  min-height: 400px;

  .account-information {
    border-radius: 10px;
    background: ${({ theme }) => theme.card.bg.secondary};
    height: 100%;

    .tab-container {
      margin-bottom: 30px;

      .divider {
        margin-top: 0px;
      }
    }

    h2 {
      margin-bottom: 5px;
    }

    .form-error {
      margin-top: -10px;
      margin-bottom: 10px;
    }

    .button-wrapper {
      gap: 10px;
      display: flex;
      padding-top: 20px;
      button {
        width: 130px;
        margin: 0px;
      }
    }

    .edit-btn {
      position: absolute;
      bottom: 50px;
    }

    .input-form {
      .input-form-label {
        color: ${({ theme }) => theme.card.font.tertiary};
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 7px;
      }

      .input-form-field {
        margin-bottom: 15px;
        border-radius: 25px;
        padding: 6.5px 24px;
      }
      .input-form-field::placeholder,
      .input-form-field-description::placeholder {
        color: ${({ theme }) => theme.input.placeholder.color};
      }
      .input-form-field-description {
      }
    }

    .phone-input-group {
      .react-tel-input .flag-dropdown {
        margin-bottom: 0px;
      }

      .phone-label {
        color: ${({ theme }) => theme.card.font.tertiary};
        font-size: 14px;
        font-weight: 500;
      }

      .input-form-field {
        background-color: ${({ theme }) => theme.tab.color.primary};
        &:disabled {
          background: #f9f9fa;
        }
      }
    }

    .image-loader {
      height: 88px;
      width: 88px;
      border-radius: 50%;
      border: 1px solid #e3e3e8;

      .loader {
        height: 100%;
      }
    }

    .view-profile {
      .label {
        color: ${({ theme }) => theme.card.font.tertiary};
        font-size: 14px;
        font-weight: 500;
        padding-bottom: 7px;
      }

      .value {
        border-radius: 8px;
        border: 1px solid ${({ theme }) => theme.card.border.quaternary};
        display: flex;
        padding: 6.5px 24px;
        align-items: flex-start;
        align-self: stretch;
        color: ${({ theme }) => theme.card.font.tertiary};
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 7px;
        min-height: 35px;

        &.email {
          word-break: break-all;
        }

        &.textarea {
          min-height: 100px;
        }
      }

      .email-input {
        width: 100%;
      }
      .email-wrapper,
      .phone-wrapper {
        display: flex;
        align-items: center;

        .value,
        .input-form .input-form-field {
          margin-bottom: 7px;
          font-size: 14px;
          border: 1px solid ${({ theme }) => theme.card.border.quaternary};
        }

        .tooltiptext {
          width: 200px;

          .link {
            cursor: pointer;
            text-decoration: underline;
          }
        }

        .email {
          margin-right: 14px;
        }

        .edit-icon {
          cursor: pointer;
        }
      }

      .email-wrapper img {
        height: 20px;
      }

      .email-tooltip {
        height: 40px;
        justify-content: flex-end;
        display: flex;
        align-items: end;
      }

      .phone-wrapper .app-tooltip img {
        height: 30px;
      }
    }

    .subscribe-plan {
      text-align: center;
      margin-top: 12px;

      .link {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  .close-account .link {
    text-decoration: underline;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    .account-information {
      h2 {
        font-size: 18px;
      }

      .view-profile .value,
      .view-profile .email-input {
        margin-bottom: 20px;
      }

      .view-profile .row {
        margin-bottom: 0px !important;
      }
    }

    .phone-col {
      margin-bottom: 0px !important;
    }
  }

  @media (max-width: 500px) {
    .account-information .button-wrapper {
      float: initial;
      text-align: center;
    }
  }

  @media (max-width: 1650px) and (min-width: 1100px) {
    .col-md-5 {
      width: 35%;

      form.phone-form {
        .control {
          width: 100%;
        }
      }
    }
  }

  @media (max-width: 1100px) {
    .change-phone-container {
      flex-direction: column;
    }

    .phone-form {
      margin-bottom: 25px;
    }
  }
`;

export const ProfileDetailsHeaderContainer = styled.div`
  .profile-wrapper {
    display: flex;
    gap: 20px;
    align-items: flex-start;
    border-bottom: 2px dashed #d5d7da;
    padding-bottom: 24px;

    .img-profile {
      width: 150px;
      height: 150px;
      border: 2px solid #00000014;
      padding: 6px;
      background: #ffffff;
      border-radius: 50%;
      box-shadow: 0px 4px 4px -2px #0a0d120a;
      box-shadow: 0px 24px 48px -12px #0a0d122e;
      margin-top: -40px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 1px solid #00000014;
      }

      .user-icon {
        width: 100%;
        height: 100%;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 50px;
        color: white;
        font-family: "Geist", sans-serif;
      }
    }

    .profile-details {
      flex: 1;
      margin-top: 24px;

      .profile-name {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 4px;

        h2 {
          font-size: 24px;
          color: #0a0d12e5;
          font-weight: 400;
          line-height: 32px;
          margin: 0px;
        }

        .edit-button {
          width: 28px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 6px;
          border: 1px solid #d5d7da;
          cursor: pointer;
        }
      }

      .invest-text {
        font-size: 16px;
        font-weight: 400;
        color: #0a0d1299;
        font-family: "Geist", sans-serif;
      }

      .bio-text {
        font-size: 16px;
        font-weight: 400;
        color: #0a0d1299;
        font-family: "Geist", sans-serif;
        margin: 4px 0px 0px;
      }

      .social-links-container {
        display: flex;
        gap: 16px;
        margin-top: 20px;

        .social-icon {
          width: 28px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
`;

export const TabContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 10px;
  border: 1px solid #e9eaeb;
  background: #fafafa;
  margin-top: 32px;
  margin-bottom: 40px;
`;

export const TabButton = styled.div`
  font-size: 14px;
  font-weight: 500;
  font-family: "Geist", sans-serif;
  cursor: pointer;
  border-radius: 6px;
  padding: 8px 16px;
  color: ${(props) => (props.active ? "414651" : "#717680")};
  background: ${(props) => (props.active ? "#fff" : "transparent")};
  box-shadow: ${(props) =>
    props.active
      ? "0 1px 3px 0 rgba(10, 13, 18, 0.1), 0 1px 2px -1px rgba(10, 13, 18, 0.1)"
      : "none"};
  transition: background 0.3s ease;
`;

export const GradientDiv = styled.div`
  height: 240px;
  border-radius: 12px;
  background: linear-gradient(45deg, #a6c0fe 0%, #ffeaf6 100%);
`;
